export const TAX_CATEGORIES = [
    { code: 'p1', label: 'Sales', group: 'Income' },
    { code: 'p2', label: 'Sales Returns', group: 'Income' },
    { code: 'p3', label: 'Interest Income', group: 'Income' },
    { code: 'p4', label: 'Other Income', group: 'Income' },
    { code: 'p5', label: 'Inventory Purchase', group: 'Cost of Goods' },
    { code: 'p6', label: 'Accounting Expense', group: 'Expenses' },
    { code: 'p7', label: 'Advertising Expense', group: 'Expenses' },
    { code: 'p8', label: 'Auto Expense', group: 'Expenses' },
    { code: 'p9', label: 'Bad Debts (Only for Accrual Accounting)', group: 'Expenses' },
    { code: 'p10', label: 'Bank Charges', group: 'Expenses' },
    { code: 'p11', label: 'Commissions', group: 'Expenses' },
    { code: 'p12', label: 'Officer Compensation', group: 'Expenses' },
    { code: 'p13', label: 'Shipping', group: 'Expenses' },
    { code: 'p14', label: 'Dues and Subscriptions', group: 'Expenses' },
    { code: 'p15', label: 'Employee Benefits', group: 'Expenses' },
    { code: 'p16', label: 'Business Gifts', group: 'Expenses' },
    { code: 'p17', label: 'Insurance (Business Liability etc)', group: 'Expenses' },
    { code: 'p18', label: 'Interest Expense', group: 'Expenses' },
    { code: 'p19', label: 'Cleaning', group: 'Expenses' },
    { code: 'p20', label: 'Laundry', group: 'Expenses' },
    { code: 'p21', label: 'Legal and Professional', group: 'Expenses' },
    { code: 'p22', label: 'Licenses and Permits', group: 'Expenses' },
    { code: 'p23', label: 'Meals 100% Deductible', group: 'Expenses' },
    { code: 'p24', label: 'Misc Expenses', group: 'Expenses' },
    { code: 'p25', label: 'Office Expense', group: 'Expenses' },
    { code: 'p26', label: 'Outside Services', group: 'Expenses' },
    { code: 'p27', label: 'Parking and Tolls', group: 'Expenses' },
    { code: 'p28', label: 'Pension or Profit Sharing', group: 'Expenses' },
    { code: 'p29', label: 'Postage', group: 'Expenses' },
    { code: 'p30', label: 'Printing', group: 'Expenses' },
    { code: 'p31', label: 'Rent', group: 'Expenses' },
    { code: 'p32', label: 'Repairs', group: 'Expenses' },
    { code: 'p33', label: 'Salaries', group: 'Expenses' },
    { code: 'p34', label: 'Security Expense', group: 'Expenses' },
    { code: 'p35', label: 'Supplies', group: 'Expenses' },
    { code: 'p36', label: 'State Taxes', group: 'Taxes' },
    { code: 'p37', label: 'Payroll Taxes', group: 'Taxes' },
    { code: 'p38', label: 'Property Taxes', group: 'Taxes' },
    { code: 'p39', label: 'Real Estate Taxes', group: 'Taxes' },
    { code: 'p40', label: 'Other Taxes', group: 'Taxes' },
    { code: 'p41', label: 'Telephone', group: 'Expenses' },
    { code: 'p42', label: 'Small Tools (<$2500 items)', group: 'Expenses' },
    { code: 'p43', label: 'Business Asset (>$2500 items)', group: 'Assets' },
    { code: 'p44', label: 'Travel', group: 'Expenses' },
    { code: 'p45', label: 'Uniforms', group: 'Expenses' },
    { code: 'p46', label: 'Utilities', group: 'Expenses' },
    { code: 'p47', label: 'Loans to Shareholders', group: 'Balance Sheet' },
    { code: 'p48', label: 'Loans from Shareholders', group: 'Balance Sheet' },
    { code: 'p49', label: 'Capital Stock', group: 'Balance Sheet' },
    { code: 'p50', label: 'Additional Paid in Capital', group: 'Balance Sheet' },
    { code: 'p51', label: 'Shareholder Profit Distribution', group: 'Balance Sheet' },
    { code: 'p52', label: 'Donations', group: 'Expenses' },
    { code: 'p53', label: 'Credit Card Payment', group: 'Payments' },
    { code: 'p57', label: 'Payroll Transfer (Non-Expense)', group: 'Payments' },
    { code: 'p54', label: 'Penalties', group: 'Expenses' },
    { code: 'p55', label: 'Business Meals 50% deductible', group: 'Expenses' },
    { code: 'p56', label: 'Entertainment Expenses', group: 'Expenses' },
    { code: 'c1', label: 'Internet', group: 'Custom' },
    { code: 'c2', label: '1099 Payments', group: 'Custom' },
    { code: 'c3', label: 'Training', group: 'Custom' },
    { code: 'c4', label: 'Therapy Supplies', group: 'Custom' },
];

export const TAX_CAT_MAP = Object.fromEntries(TAX_CATEGORIES.map(c => [c.code, c]));
export const TAX_GROUPS = [...new Set(TAX_CATEGORIES.map(c => c.group))];
export const TAX_CAT_LABELS = Object.fromEntries(TAX_CATEGORIES.map(c => [c.code, c.label]));
